<script setup>
import BaseIcon from '@/components/BaseIcon.vue'
import LoaderInComponent from '@/components/LoaderInComponent.vue'
import { mdiRefresh } from '@mdi/js'
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'

// import SimpleCABalanceItem from '@/components/CurrencyAccounts/SimpleCaBalance/SimpleCABalanceItem.vue'
import { useAuthStore } from '@/stores/auth_store'
import { useUserStore } from '@/stores/user_store'
// import { useCurrencyAccountsStore } from '@/stores/currencyAccounts'
import { parseMoney } from '@/money-options'

const auth = useAuthStore()
const user = useUserStore()

const loadingVisible = ref(false)
const timerId = ref(undefined)
const balance = computed(() => user.balance || 0)

onBeforeMount(async () => {
  await handleClickRefresh()

  timerId.value = setInterval(async () => {
    await handleClickRefresh()
  }, 30000)
})
onBeforeUnmount(() => {
  if (timerId.value) {
    clearTimeout(timerId.value)
  }
})
async function handleClickRefresh() {
  if (auth.authToken) {
    loadingVisible.value = true
    await user
      .getUserBalance()
      .then(() =>
        setTimeout(() => {
          loadingVisible.value = false
        }, 500)
      )
  }
}
</script>

<template>
    <BaseIcon
      :path="mdiRefresh"
      class="cursor-pointer xs:hidden md:flex"
      size="20"
      @click="handleClickRefresh"
    />
    <div
      class="flex flex-row justify-start items-center w-full h-full gap-1 xs:border-b xs:dark:border-b-borderColor md:border-none"
    >
      <LoaderInComponent class="rounded-xl" :loading-visible="loadingVisible" />
      <div class="flex flex-col md:ml-3">
        <div class="xs:text-[14px] md:text-[18px]">Баланс: {{ parseMoney(balance) }}</div>
      </div>
    </div>
</template>
